import BaseModel from '@/model/BaseModel';

/**
 * @typedef UsuarioDTO
 * @property {string} id
 * @property {string} username
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} fullName
 * @property {string} email
 */
export class ModelUsuario extends BaseModel {
  constructor() {
    super();
    this.id = null;
    this.username = null;
    this.firstName = null;
    this.lastName = null;
    this.fullName = null;
    this.email = null;
  }

  /** @param {UsuarioDTO} dto */
  static fromObject(dto) {
    const instance = new ModelUsuario();
    instance.id = dto.id;
    instance.username = dto.username;
    instance.firstName = dto.firstName;
    instance.lastName = dto.lastName;
    instance.fullName = dto.fullName;
    instance.email = dto.email || dto.emailAddress;
    return instance;
  }
}
